<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KTextareaField from '@/components/fields/KTextareaField.vue';
import SmsChatTemplateAddVMenu from '@/components/vMenus/SmsChatTemplateAddVMenu.vue';
import useForm from '@/composables/useForm';
import {
  getMaxLengthValidationRule,
  requiredValidationRule,
} from '@/helpers/validationRules';

export interface InitialData {
  message?: string;
}

export interface ValidData {
  message: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const maxLength = 160;

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (!formData.message?.length) return;
  if (formData.message.length > maxLength || formData.message.length <= 0) {
    return;
  }
  const validData: ValidData = {
    message: formData.message,
  };
  emit('submit', event, validData);
});

function handleEnterKeydown(event: KeyboardEvent) {
  if (event.shiftKey) return;
  void handleSubmit();
  event.preventDefault();
}

function handleMenuItemClick(event: PointerEvent, message: string) {
  formData.message = message;
}
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.chatMainSendForm"
    data-testid="chatMainSendForm"
    @submit.prevent="handleSubmit"
  >
    <div :class="$style.textareaAndSubmit">
      <KTextareaField
        v-model="formData.message"
        size="large"
        :disabled="props.loading"
        :rules="[requiredValidationRule, getMaxLengthValidationRule(maxLength)]"
        :maxlength="maxLength"
        :rows="1"
        :class="$style.field"
        placeholder="Type a message"
        counter
        no-resize
        @keydown.enter="handleEnterKeydown"
      />
      <KBtn
        type="submit"
        size="lg"
        priority="info"
        icon="mdi-send"
        :loading="props.loading"
        :class="$style.submit"
        :disabled="!isValid || props.loading"
      />
    </div>
    <div :class="$style.template">
      <SmsChatTemplateAddVMenu @item-click="handleMenuItemClick" />
    </div>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.chatMainSendForm {
}
  .field {
  }
  .submit {
  }
    .counter {
      font-size: 14px;
      color: colors.$color-text-tertiary;
    }
  .textareaAndSubmit {
    display: flex;
  }
  .template {
    margin-left: -1px;
  }
</style>
